module.exports = __webpack_public_path__ + "img/0Q3B3814-26_H_WoodMatted.801f0576.jpg";